export default "__VITE_ASSET__cfefa542__"